import JSONEditor from 'jsoneditor/dist/jsoneditor.min'
import 'jsoneditor/dist/jsoneditor.min.css'
import './editor.scss'

const modes = ['code', 'tree', 'view', 'form', 'text']

export default {
  name: 'json-editor',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '500px'
    },
    options: {
      type: Object,
      default: {}
    },
    value: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      jsoneditor: null
    }
  },
  methods: {
    getOptions() {
      const defaults = {
        escapeUnicode: false,
        history: true,
        indentation: 2,
        mode: modes[0],
        modes: modes.slice(0),
        navigationBar: true,
        search: false,
        statusBar: true,
        sortObjectKeys: false
      }
      return Object.assign({}, defaults, this.options, {
        onChange: this.onChange,
        onError: this.onError
      })
    },
    onChange() {
      const value = this.jsoneditor.get()
      this.$emit('input', value)
    },
    onError(error) {
      this.$emit('error', error)
    }
  },
  render(h) {
    return h('div', {
      ref: 'jsoneditor',
      style: `width:${this.width};height:${this.height}`
    })
  },
  mounted() {
    this.jsoneditor = new JSONEditor(this.$refs.jsoneditor, this.getOptions(), this.value)
    this.onChange()
  },
  beforeDestroy() {
    this.jsoneditor.destroy()
    this.jsoneditor = null
  }
}



// WEBPACK FOOTER //
// ./src/components/common/json-editor/editor.js